export default "__VITE_ASSET__c2050368__"